/**
 * Build the multipart body for a recruiter or settings save.
 *
 * Null and undefined are skipped rather than sent, so a field can only be
 * cleared by sending an empty string — which the API relies on: a blank heading
 * is stored as null, and an empty `terms_document_path` deletes the uploaded
 * document. Empty strings must therefore survive this function untouched.
 */
export default function toFormData(values: Record<string, unknown>): FormData {
  const formData = new FormData();

  for (const [key, val] of Object.entries(values)) {
    // Skip null or undefined values
    if (val == null) {
      continue;
    }

    if (Array.isArray(val)) {
      // Append array values as `key[]` so Laravel parses them as an array
      val.forEach((item) => formData.append(`${key}[]`, item as string | Blob));
    } else if (typeof val === "boolean") {
      // Convert boolean values to "1" or "0" for Laravel
      formData.append(key, val ? "1" : "0");
    } else {
      formData.append(key, val as string | Blob);
    }
  }

  return formData;
}
